import { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { Plus, Trash2 } from "lucide-react";

export default function Categories() {
    const [rows, setRows] = useState([]);
    const [name, setName] = useState("");
    const [desc, setDesc] = useState("");
    const [err, setErr] = useState("");

    const load = () => api.get("/categories").then((r) => setRows(r.data));
    useEffect(() => {
        load();
    }, []);

    const add = async (e) => {
        e.preventDefault();
        setErr("");
        try {
            await api.post("/categories", { name, description: desc, active: true });
            setName("");
            setDesc("");
            load();
        } catch (ex) {
            setErr(formatApiError(ex));
        }
    };
    const toggle = async (c) => {
        await api.patch(`/categories/${c.id}`, { active: !c.active });
        load();
    };
    const del = async (c) => {
        await api.delete(`/categories/${c.id}`);
        load();
    };

    return (
        <div className="space-y-4 max-w-3xl" data-testid="categories-page">
            <h1 className="text-2xl font-bold tracking-tight">Categories</h1>
            <form
                onSubmit={add}
                className="flex gap-2 items-end bg-card border border-border rounded-md p-3"
            >
                <div className="flex-1">
                    <label className="text-[10px] uppercase tracking-[0.2em] text-muted-foreground font-mono">
                        Name
                    </label>
                    <input
                        data-testid="category-name-input"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        required
                        className="w-full bg-background border border-border rounded-md px-3 py-2 text-sm focus:outline-none focus:border-primary"
                    />
                </div>
                <div className="flex-1">
                    <label className="text-[10px] uppercase tracking-[0.2em] text-muted-foreground font-mono">
                        Description
                    </label>
                    <input
                        data-testid="category-desc-input"
                        value={desc}
                        onChange={(e) => setDesc(e.target.value)}
                        className="w-full bg-background border border-border rounded-md px-3 py-2 text-sm focus:outline-none focus:border-primary"
                    />
                </div>
                <button
                    data-testid="category-add-btn"
                    className="px-3 py-2 bg-primary text-primary-foreground rounded-md text-sm inline-flex items-center gap-1"
                >
                    <Plus className="size-3.5" /> Add
                </button>
            </form>
            {err && (
                <div className="text-xs text-red-400 border border-red-500/30 bg-red-500/10 px-3 py-2 rounded-md">
                    {err}
                </div>
            )}
            <div className="bg-card border border-border rounded-md divide-y divide-border">
                {rows.map((c) => (
                    <div
                        key={c.id}
                        className="flex items-center gap-3 px-3 py-2 text-sm"
                        data-testid={`category-row-${c.id}`}
                    >
                        <div className="flex-1">
                            <div className="font-medium">{c.name}</div>
                            <div className="text-xs text-muted-foreground">
                                {c.description || "—"}
                            </div>
                        </div>
                        <button
                            data-testid={`category-toggle-${c.id}`}
                            onClick={() => toggle(c)}
                            className={`text-[10px] px-2 py-0.5 rounded-sm border uppercase tracking-wider ${
                                c.active
                                    ? "bg-emerald-500/10 text-emerald-400 border-emerald-500/30"
                                    : "bg-muted text-muted-foreground border-border"
                            }`}
                        >
                            {c.active ? "Active" : "Inactive"}
                        </button>
                        <button
                            data-testid={`category-delete-${c.id}`}
                            onClick={() => del(c)}
                            className="text-xs text-red-400 hover:text-red-300"
                        >
                            <Trash2 className="size-3.5" />
                        </button>
                    </div>
                ))}
                {rows.length === 0 && (
                    <div className="text-sm text-muted-foreground p-6 text-center">
                        No categories yet.
                    </div>
                )}
            </div>
        </div>
    );
}
